/**
 * „Beim Öffnen direkt zur Kasse“ (nur in der App): Einstellung dieses Geräts, lokal gespeichert. Ohne Speicher gilt
 * „aus“, nichts bricht. Es steht nur ein Ja/Nein im Speicher, keine Personendaten.
 */
const KEY = 'barso.pos.directStart';

export function readDirectStart(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function writeDirectStart(on: boolean): void {
  try {
    if (on) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    // ohne Speicher bleibt die Einstellung aus
  }
}
